// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"a8a5dbb5","104":"26605a85","334":"09f61b23","750":"92bb5a11"}[chunkId] + ".chunk.js";
};